<template
  ><b-container fluid v-if="scoreReport">
    <b-row>
      <b-col class="top_bar" :style="{ background: scoreReport.color }" />
    </b-row>
    <b-row :style="{ padding: '0 60px', 'margin-top': '35px' }"
      ><b-col class="tsny_border-bottom"
        ><b-row>
          <b-col class="p-0">
            <div class="page_title pl-0 pt-0">{{ scoreReport.examName }}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="p-0 pr-3"
            ><p class="tsny_text">
              Below, you'll find a detailed breakdown of your performance on
              this practice exam. You'll see a total composite score that
              represents what you got on the exam overall, as well as data about
              your performance on specific elements of the test. <br /><br />
              Click on the appropriate drop down menus to learn more about how
              you did with the different subject areas covered in the exam. Be
              sure to review your results with your tutor, and check out the
              Question Bank if you want to find out more about specific
              questions on this practice exam.
            </p></b-col
          >
        </b-row></b-col
      ><b-col class="tsny_border-bottom tsny_box-fill tsny_box-padding">
        <composite-scores :score-report="scoreReport" /> </b-col
    ></b-row>
    <b-row class="indentation"
      ><b-col :style="{ 'max-width': maxWidth }">
        <b-row>
          <b-col>
            <subscore-breakdown
              id="subscoreBreakdown"
              :subscore-breakdown="scoreReport.subscoreBreakdown"
              :color="scoreReport.color"
              class="mt-5 mb-5"
            />
          </b-col>
        </b-row>
        <b-row
          ><b-col
            ><sat-scores
              v-if="scoreReport.courseId === 'SAT'"
              :score-report="scoreReport"/>
            <act-scores
              v-if="scoreReport.courseId === 'ACT'"
              :score-report="scoreReport"/></b-col></b-row></b-col
      ><b-col class="col-auto" :style="{ 'padding-right': '60px' }"
        ><score-report-nav :score-report="scoreReport"/></b-col
    ></b-row>
  </b-container>
</template>

<script>
import CompositeScores from "../../components/ScoreReports/CompositeScores";
import SubscoreBreakdown from "../../components/ScoreReports/SubscoreBreakdown";
import SatScores from "../../components/ScoreReports/SatComponents/SatScores";
import ScoreReportNav from "../../components/ScoreReports/ScoreReportNav";
import ActScores from "../../components/ScoreReports/ActComponents/ActScores";
export default {
  name: "ScoreReport",
  components: {
    ActScores,
    ScoreReportNav,
    SatScores,
    SubscoreBreakdown,
    CompositeScores
  },
  props: {
    scoreReport: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    // This is a brute-force solution to the myriad issues I had with the answer key tables growing beyond their columns and breaking the page layout
    maxWidth() {
      return `${this.windowWidth - 612}px`;
    }
  },
  mounted() {
    window.addEventListener("resize", this.widthHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.widthHandler);
  },
  methods: {
    widthHandler() {
      this.windowWidth = window.innerWidth;
    }
  }
};
</script>

<style scoped>
.indentation {
  margin-left: 30px;
}
</style>
